import { LoadingButton } from '@mui/lab';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Alert,
} from '@mui/material';
import { FC, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { EditIcon } from '../../../vectors/index';
import PaymentInformationForm from '@features/employerOnboarding/components/PaymentInformationForm/PaymentInformationForm';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

type UpdateCardInfoProps = {
  handleClose: () => void;
  selectedPlanId: string
};

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY);

const UpdateCardInfo: FC<UpdateCardInfoProps> = ({ handleClose, selectedPlanId }) => {
  const [errorText, setErrorText] = useState<string>('');


  return (
    <Dialog
      open
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        <IconButton sx={{ position: 'absolute', top: 5, right: 5 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <br />
        <EditIcon />
        <br />
        <Typography variant="h4" >
          Add Payment Info
        </Typography>
      </DialogTitle>
      <DialogContent>
        {errorText && <Alert sx={{ margin: "10px 0" }} severity="error">{errorText}</Alert>}
        <Elements stripe={stripePromise}>
          <PaymentInformationForm
            selectedPlanId={selectedPlanId}
            handleClose={handleClose}
            isEnterprise={true}
          />
        </Elements>
      </DialogContent>
    </Dialog>
  );
};

export default UpdateCardInfo;
